function nextFrame() {
  return new Promise((resolve) => requestAnimationFrame(resolve));
}

class ContentCarousel extends HTMLElement {
  locked = false;
  direction = '';
  intervalDuration = 10000;
  startX = 0;

  get slides() {
    return this.querySelectorAll('.teaser');
  }

  get slideWidth() {
    return this.slides[0]?.getBoundingClientRect().width || 0;
  }

  connectedCallback() {
    this.container = this.querySelector('[sc-container]');
    this.leftButton = this.querySelector('[sc-left]');
    this.rightButton = this.querySelector('[sc-right]');
    this.autoplay = this.dataset.autoplay;
    this.intervalDuration = 5000;

    this.interval = this.dataset.interval;
    if (this.interval && !isNaN(this.interval)) {
      this.intervalDuration = parseInt(this.interval, 10);
    }

    this.attachEvents();
    if (this.autoplay == 'true' && this.slides.length > 1) {
      this.interval = setInterval(() => this.move('right'), this.intervalDuration);
    }
  }

  attachEvents() {
    if (this.slides.length > 1) {
      this.leftButton?.addEventListener('click', () => this.move('left'));
      this.rightButton?.addEventListener('click', () => this.move('right'));
      this.container.addEventListener('touchstart', (e) => (this.startX = e.touches[0].clientX));
      this.container.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        if (Math.abs(this.startX - endX) > 50) {
          this.move(this.startX > endX ? 'right' : 'left');
        }
      });

      this.container.addEventListener('transitionend', async () => {
        if (this.direction === 'right') {
          this.container.classList.add('suppress-transition');
          await nextFrame();
          this.container.style.translate = '0px';
          this.slides[0]?.parentElement.appendChild(this.slides[0]);
          await nextFrame();
        }
        this.resetState();
      });
    }
  }

  resetState() {
    this.container.classList.remove('suppress-transition');
    this.locked = false;
    this.direction = '';
  }

  move(direction) {
    if (this.locked) return;
    this.locked = true;
    this.direction = direction;
    direction === 'left' ? this.moveLeft() : this.moveRight();
  }

  async moveLeft() {
    const last = this.slides[this.slides.length - 1];
    this.container.classList.add('suppress-transition');
    await nextFrame();
    last?.parentElement.prepend(last);
    this.container.style.transform = `translateX(-${this.slideWidth}px)`;
    await nextFrame();
    this.container.classList.remove('suppress-transition');
    await nextFrame();
    this.container.style.transform = `translateX(0px)`;
  }

  async moveRight() {
    const offset = this.slideWidth + this.gapSize;
    this.container.style.transform = `translateX(-${offset}px)`;

    const onTransitionEnd = async () => {
      this.container.removeEventListener('transitionend', onTransitionEnd);

      this.container.classList.add('suppress-transition');
      await nextFrame();

      this.container.style.transform = 'translateX(0px)';
      await nextFrame();

      this.container.classList.remove('suppress-transition');
      this.resetState();
    };

    this.container.addEventListener('transitionend', onTransitionEnd);
  }

  get gapSize() {
    const style = getComputedStyle(this.slides[0]);
    return parseFloat(style.marginRight) || 0;
  }
}

customElements.define('content-carousel', ContentCarousel);
